import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaArtesanos from './TablaArtesanos';

const Artesanos: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <TablaArtesanos />
    </Box>
  );
};

export default Artesanos;
